import React, { FC, Fragment, useState } from 'react';
import { Button, Grid } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { camelCasify } from '../../../../utils/navigation';
import { SoknadSteg } from '../../../../components/registering/utils/registerEnums';
import { StartRegistrationDialog } from '../../../../components/startRegistrationDialog';
import { isBuildingGarageOrAnnex } from '../../../../utils/matrikkelBygningsTyper';
import { initSoknad } from '../../../../store/registration/actions';
import { ApiRequestError } from '../../../../services/api';
import { ErrorBox } from '../../../../components/errorBox';

interface EnergyAnalysisErrorProps {
  onClick: () => void;
  error?: ApiRequestError | null;
}

export const EnergyAnalysisError: FC<EnergyAnalysisErrorProps> = ({ onClick, error }) => (
  <ErrorBox onRetry={onClick} error={error} />
);

interface CreateApplicationLinkProps {
  bygningsTypeNummer: string;
  isHovedbygg: boolean;
  soknadSteg?: SoknadSteg;
}

export const CreateApplicationLink: FC<CreateApplicationLinkProps> = ({
  bygningsTypeNummer,
  isHovedbygg,
  soknadSteg
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const dispatch = useDispatch();

  const initAndNavigateToNewSoknad = () => {
    dispatch(initSoknad());
    navigate('../ny-soknad');
  };

  const startRegistration = () => {
    if (!isHovedbygg || isBuildingGarageOrAnnex(bygningsTypeNummer)) {
      return setIsDialogOpen(true);
    }

    initAndNavigateToNewSoknad();
  };

  return (
    <Fragment>
      <Grid item xs={12} sm="auto">
        <Button fullWidth variant="secondary" onClick={startRegistration}>
          {t('documentsForEnovaApplication.create', {
            context: soknadSteg ? camelCasify(soknadSteg) : undefined
          })}
        </Button>
      </Grid>

      <StartRegistrationDialog
        bygningsTypeNummer={bygningsTypeNummer}
        isHovedBygg={isHovedbygg}
        isOpen={isDialogOpen}
        onConfirm={initAndNavigateToNewSoknad}
        onClose={() => setIsDialogOpen(false)}
      />
    </Fragment>
  );
};
